import { isMac } from 'shared/lib/deviceDetector'
import { Box, type ITooltipProps, Typography } from 'shared/ui'
import styles from 'widgets/MessageField/ui/FieldActions/styles.module.scss'

export const sendActionTooltipProps: ITooltipProps = {
  label: (
    <Box display='flex' alignItems='center' gap={1.5}>
      <Typography variant='body-md-regular' ariaLabel='tooltipSend'>
        Send
      </Typography>
      <Box display='flex' gap={0.5}>
        <Typography
          className={styles.tooltipElement}
          variant='body-sm-medium'
          ariaLabel='tooltipKey'
        >
          {isMac ? '⌘' : 'Ctrl'}
        </Typography>
        <Typography
          className={styles.tooltipElement}
          variant='body-sm-medium'
          ariaLabel='tooltipEnter'
        >
          Enter
        </Typography>
      </Box>
    </Box>
  ),
  placement: 'top',
}
